export default {
  // user
  userProfile: '/user/ContactInfo',
  userPublicProfile: '/user/PublicProfile',
  userHeadShot: '/user/PublicProfileHeadshot',
  userOrders: '/user/orders',
  userChangePassword: '/user/ChangePassword',
  // user email
  checkEmail: '/user/IsEmailChanged',
  confirmEmail: '/user/IsCodeValid',
  // countries
  countries: '/misc/GetCountries',
  usaStates: '/misc/GetStates',
  // Jobs
  jobs: {
    jobLogo: '/Jobs/JobLogo',
    jobLogoFromSupplier: '/Jobs/JobLogoFromSupplier',
    packages: (id: string): string => `/Jobs/PrepaidPackages/${id}`,
    postPrepaidPurchase: (id: string, validateOnly: boolean): string => `/Jobs/PrepaidPurchase/${id}?validateOnly=${validateOnly}`,
    paymentIntentPrepaidPurchase: '/jobs/paymentintentprepaidpurchase',
    industrySectors: (id: string): string => `/Jobs/IndustrySectors/${id}`,
    employmentTypes: '/Jobs/EmploymentTypes',
    jobListingTypes: (id: string): string => `/Jobs/JobListingTypes/${id}`,
    getUserCurrentInfo: '/Jobs/GetCurrentUserInfo',
    salaryUnits: '/Jobs/SalaryUnits',
    salaryTypes: '/Jobs/SalaryTypes',
    saveJobData: '/Jobs/SaveJobData',
    benefitQuote: '/Jobs/BenefitQuote',
    benefitCheckout: '/Jobs/BenefitCheckout',
    releaseBenefitCheckout: '/Jobs/ReleaseBenefitCheckout',
    postJobListing: (id: string, validateOnly: boolean): string => `/Jobs/PostJobListing/${id}?validateOnly=${validateOnly}`,
    postJobListingWithBenefit: (id: string, validateOnly: boolean): string => `/Jobs/PostJobListingWithBenefit/${id}?validateOnly=${validateOnly}`,
    getJobTempData: (guid: string): string => `/Jobs/PostJobTempData/${guid}`,
    // Named for the temp-storage bucket each one clears, because there are three of
    // them and two used to start with a Cyrillic ES (U+0441) instead of an ASCII "c"
    // — which is the only reason they could coexist with the ASCII `clearTempData`
    // on the prepaid line below without either shadowing the other. Normalizing the
    // spelling in place would have silently collapsed two keys into one.
    clearPostJobTempData: (guid: string): string => `/Jobs/ClearTempData/${guid}`,
    brewboundCompanyList: (text: string): string => `/Jobs/CompanyList/${text}`,
    jobData: ({ siteId, guid }: { siteId: string; guid: string }): string => `/Jobs/JobInfo/${siteId}/${guid}`,
    postprepaidlisting: ({ siteId, guid }: { siteId: string; guid: string }): string => `/Jobs/PostPrepaidListing/${siteId}/${guid}`,
    upgradeJob: (siteId: string, guid: string, validateOnly: boolean): string => `/Jobs/UpgradeJobListing/${siteId}/${guid}?validateOnly=${validateOnly}`,
    paymentIntentForUpgrade: '/jobs/paymentintentforupgrade',
    editJobListing: (id: string): string => `/Jobs/EditJobListing/${id}`,
    stopJobListing: (guid: string): string => `/Jobs/StopListing/${guid}`,
    reactivateFreeJobListing: (guid: string): string => `/Jobs/ReactivateFree/${guid}`,

    getReactivateJobTempData: (guid: string): string => `/Jobs/ReactivateJobTempData/${guid}`,
    reactivateJobListing: (id: string, validateOnly: boolean): string => `/Jobs/Reactivate/${id}?validateOnly=${validateOnly}`,
    saveTempDataReactivate: '/Jobs/SaveReactivateJobData',
    clearReactivateTempData: (guid: string): string => `/Jobs/ClearTempReactivateData/${guid}`,

    saveTempDataJobPrepaid: '/Jobs/PostPrepaidTempData',
    getJobPrepaidTempData: (guid: string) => `/Jobs/PostPrepaidTempData/${guid}`,
    postJobPrepaid: (siteId: string) => `/Jobs/PostPrepaidListing/${siteId}`,
    // The prepaid bucket — a third, distinct endpoint (not a duplicate of the above).
    clearTempData: (siteId: string) => `/Jobs/ClearPostPrepaidTempData/${siteId}`,
    getReceiptData: (siteId: string) => `/Jobs/Receipt/${siteId}`,
    getPaymentIntent: '/Jobs/PaymentIntent',
    searchSupplier: '/Jobs/SearchSupplier',
    contact: '/Jobs/Contact',
    accountHome: '/Jobs/AccountHome',
    accountApplicants: '/Jobs/AccountApplicants',
    myApplications: '/Jobs/MyApplications',
    activeJobsListing: '/Jobs/ActiveJobsListing',
    inactiveJobsListing: '/Jobs/InactiveJobsListing',
    jobsPrepaid: '/Jobs/JobsPrepaid',
    jobsPrepaidDetail: (guid: string): string => `/Jobs/JobsPrepaidDetail/${guid}`,
    jobsApplicants: (guid: string): string => `/Jobs/JobsApplicants/${guid}`,
    jobsApplicantDetail: (eguid: string, applicationId: number | string): string => `/Jobs/JobsApplicantDetail/${eguid}/${applicationId}`,
    markAsReadJobsApplication: (applicationId: number | string): string => `/Jobs/MarkAsReadJobsApplicantion/${applicationId}`,
    applicantFile: (eguid: string, fileGuid: string): string => `/Jobs/ApplicantFile/${eguid}/${fileGuid}`,
    applicationStatus: (applicationId: number | string): string => `/Jobs/ApplicationStatus/${applicationId}`,
    applicationRating: (applicationId: number | string): string => `/Jobs/ApplicationRating/${applicationId}`,
    applicationNotes: (applicationId: number | string): string => `/Jobs/ApplicationNotes/${applicationId}`,
    applicationNote: (noteId: number | string): string => `/Jobs/ApplicationNote/${noteId}`,
    applicationReviewRequest: (applicationId: number | string): string => `/Jobs/ApplicationReviewRequest/${applicationId}`,
    applicationReviewRequestResend: (noteId: number | string): string => `/Jobs/ApplicationReviewRequest/${noteId}/Resend`,
    jobHiringTeam: (eguid: string): string => `/Jobs/JobHiringTeam/${eguid}`,
    jobHiringTeamMember: (eguid: string, userId: number): string => `/Jobs/JobHiringTeam/${eguid}/${userId}`,
    jobHiringTeamResend: (eguid: string, userId: number): string => `/Jobs/JobHiringTeam/${eguid}/${userId}/Resend`,
    mySavedJobs: '/Jobs/MySavedJobs',
    savedJob: (slug: string): string => `/Jobs/SavedJob/${encodeURIComponent(slug)}`
  }
};
